import React from 'react';
import { infoSources, systemNeeds } from '../data/salesPage';
export function InformationSection() {
  return <section aria-labelledby="informacion" className="bg-ink" data-id="element-101" data-mp="uchjdvakq8st">
      <div className="mx-auto max-w-5xl px-5 py-20 sm:py-28" data-id="element-102" data-mp="yd1g4xr8jaef">
        <h2 id="informacion" className="max-w-3xl font-display text-3xl font-black uppercase leading-[1.05] text-bone sm:text-5xl" data-id="element-103" data-mp="ybqb6um1zwlq">
          El problema no siempre es la falta de información
        </h2>
        <p className="mt-6 text-lg text-bone-muted" data-id="element-104" data-mp="182l0k7uljcbe">Hoy existe información por todos lados.</p>

        <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2" aria-label="Fuentes de información" data-id="element-105" data-mp="1d02zd5ewgb5o">
          {infoSources.map(source => <li key={source} className="font-display text-2xl font-extrabold text-bone-dim sm:text-3xl" data-id="element-106" data-mp="1m2c6rmevfoeu">
              {source}.
            </li>)}
        </ul>

        <div className="mt-14 grid gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-107" data-mp="3jugesxqi5ib4">
          <div className="space-y-4 text-lg leading-relaxed text-bone-muted" data-id="element-108" data-mp="3nuqq8px2d0xd">
            <p className="text-xl text-bone" data-id="element-109" data-mp="8b0or5njod19">Pero tener información no significa saber cómo aplicarla.</p>
            <p data-id="element-110" data-mp="3j0otd7h5k4o">Lo que muchas personas necesitan no es otra dieta de moda.</p>
            <p data-id="element-111" data-mp="3uptscnpqpvcd">Necesitan:</p>
            <p className="font-display text-6xl font-black uppercase leading-none text-lime sm:text-7xl" data-id="element-112" data-mp="3ur4vqmf9x12y">Un sistema.</p>
          </div>

          <div className="rounded-3xl border border-ink-line bg-ink-raised p-7 sm:p-9" data-id="element-113" data-mp="3ppfgeul0q192">
            <p className="text-lg text-bone-muted" data-id="element-114" data-mp="r7jz1ya346ze">Un sistema que les diga:</p>
            <ol className="mt-5 divide-y divide-ink-line" data-id="element-115" data-mp="mb30091ck87j">
              {systemNeeds.map(need => <li key={need} className="py-3.5 font-display text-xl font-bold text-bone first-letter:uppercase" data-id="element-116" data-mp="h9vru8val70c">
                  {need}
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}